import { render } from "./BaseFormButtons.vue?vue&type=template&id=7deb8dc0"
import script from "./BaseFormButtons.vue?vue&type=script&lang=js"
export * from "./BaseFormButtons.vue?vue&type=script&lang=js"

import "./BaseFormButtons.vue?vue&type=style&index=0&id=7deb8dc0&lang=css"

import exportComponent from "/builds/fLte45evJ/0/trinax/jeopardy.trinax.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__